import './flexible-spaces.css';

function delayedLoad() {
  document.body.classList.add('delayed-load');
}

window.addEventListener('scroll', delayedLoad, {once: true, passive: true});
document.addEventListener('click', delayedLoad, {once: true, passive: true});
document.addEventListener('keydown', delayedLoad, {once: true, passive: true});